<outlaw-mux-player
  #player
  [src]="streamUrl"
  [playbackId]="playbackId"
  [playbackToken]="playbackToken"
  [poster]="poster"
  [controls]="controls"
  [muted]="muted"
  [loop]="loop"
  [startTime]="watchedDuration"
  accentColor="#e21f46"
  (pause)="onPause($event)"
  (timeUpdate)="onTimeUpdate($event)"
  (ended)="onEnded()"
  (error)="onError($event)"
></outlaw-mux-player>
